import { decode } from 'jsonwebtoken';
import type { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';

import { BASE_URL, CLAIM_ROUTES, steps } from './card/constants';
import type { ClaimFlowGetServerSidePropsPayload, Step } from './card/types';

export const decodeQueryParam = (str: string): string => decodeURIComponent((str + '').replace(/\+/g, '%20'));

export const checkTokenExpiration = (token: string): boolean => {
  const decodedToken = decode(token);

  if (!decodedToken || typeof decodedToken !== 'object' || !decodedToken.exp) {
    return true;
  }

  const expired = decodedToken.exp * 1000 < Date.now();
  return expired;
};

export const getCardClaimFlowServerSideProps = async (
  context: GetServerSidePropsContext,
): Promise<GetServerSidePropsResult<ClaimFlowGetServerSidePropsPayload>> => {
  const stepKey = context.query.stepKey as Step;

  // Skip over first step
  if (stepKey === 'get-started') {
    const queryString = new URLSearchParams(context.query as Record<string, string>);
    const redirectUrl = `${CLAIM_ROUTES.ADD_DETAILS}?${queryString}`;

    return {
      redirect: {
        destination: redirectUrl,
        permanent: false,
      },
    };
  }

  const flowSteps = steps.slice(1, steps.length);

  const currentStepIndex = flowSteps.indexOf(stepKey as Step);
  const currentStep = flowSteps[currentStepIndex];

  const atStart = currentStepIndex === 0;
  const atFinish = currentStepIndex === flowSteps.length - 1;

  const nextStep = flowSteps[currentStepIndex + 1];
  const previousStep = flowSteps[currentStepIndex - 1];

  const nextStepUrl = !atFinish ? `${BASE_URL}/${nextStep}` : null;
  const previousStepUrl = !atStart ? `${BASE_URL}/${previousStep}` : null;

  return {
    props: {
      currentStepIndex,
      currentStep,
      nextStepUrl,
      previousStepUrl,
    },
  };
};
